import React, { useState } from 'react'
import ReactMde from 'react-mde'
import { converter } from 'src/Utils/ShowDownConverter'
import { NewMarkdownEditorWrapper } from './NewMarkdownEditor.styles'

export const NewMarkdownEditor = ({
  value,
  onChange,
  placeholder,
}: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}): JSX.Element => {
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write')

  return (
    <NewMarkdownEditorWrapper>
      <ReactMde
        value={value}
        onChange={onChange}
        selectedTab={selectedTab}
        onTabChange={setSelectedTab}
        generateMarkdownPreview={(markdown) =>
          Promise.resolve(converter.makeHtml(markdown))
        }
        childProps={{
          textArea: { placeholder },
        }}
      />
    </NewMarkdownEditorWrapper>
  )
}
